import React, { Component } from 'react'
import Axios from 'axios'
import Axios2 from '../../Axios'
import './Summary.css'
import { ToastContainer, toast } from 'react-toastify'
import Loader from '../Loader'
import { Urls } from '../../Urls'
import { logActivity } from '../Utilities'

const url = {
    "upload": "/file_upload",
    "header_mapping": "/header_mapping",
    "vendor1": "/directMatchVendor",
    "truck1": "/directMatchTruck",
    "final_consolidation": "/FinalConsolidation"
}

var datasetStatus = []
class Summary extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fetched_data: [],
            loader: false,
            role: undefined,
            isSearched: false,
            searchedList: [],
            searchKeyword: 'user',
            updatedList: []
        }
    }


    componentDidMount = () => {
        // logActivity([
        //     {
        //         'screen': 'Summary',
        //         'module': 'Summary',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.getElementById("header").style.opacity = "0.5"
        if (localStorage.getItem('accessToken') === undefined || localStorage.getItem('accessToken') === "") {
            // Call API for fetching summary for stored dataset id
            sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
            this.setState({
                loader: true
            }, () => {
                Axios2.get(Urls.getUser)
                    .then(res => {
                        localStorage.setItem('userid', res.data[0].email)

                        // Call summary details for logged in user
                        document.title = "DC | Summary Screen"
                        Axios.post(Urls.summary, { userid: localStorage.getItem('userid') })
                            .then(response => {
                                this.setState({

                                    fetched_data: response.data.data,
                                    updatedList: response.data.data,
                                    role: response.data.role,
                                    loader: false
                                })
                                document.getElementById("header").style.opacity = "1"
                            })
                            .catch(error => {
                                this.setState({ loader: false })
                                document.getElementById("header").style.opacity = "1"
                                toast.error("Error while fetching your data")
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        console.log(error)
                        toast.error('Error while fetching user details')
                        this.setState({ loader: false })
                        document.getElementById("header").style.opacity = "1"
                    })
            })
        }
        else {
            document.getElementById("header").style.opacity = "0.5"
            document.title = "DC | Summary Screen"
            var body = {
                "userid": localStorage.getItem("userid")
            }

            this.setState({
                loader: true
            }, () => {
                Axios2.get(Urls.getUser)
                    .then(res => {
                        localStorage.setItem('userid', res.data[0].email)

                        // Call summary details for logged in user
                        document.title = "DC | Summary Screen"
                        var body = {
                            "userid": localStorage.getItem("userid"),
                            'key': 'fetch'
                        }
                        Axios.post(Urls.summary, body)
                            .then(response => {
                                this.setState({
                                    fetched_data: response.data.data,
                                    role: response.data.role,
                                    loader: false
                                })
                                document.getElementById("header").style.opacity = "1"
                            })
                            .catch(error => {
                                this.setState({ loader: false })
                                document.getElementById("header").style.opacity = "1"
                                toast.error("Error while fetching your data")
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        console.log(error)
                        this.setState({ loader: false })
                        toast.error('Error while fetching user details')
                        document.getElementById("header").style.opacity = "1"
                    })
            })
        }
    }

    sort = (field) => {
        switch (field) {
            case 'spend':

                break;

            case 'volume':

                break;

            case 'status':

                break;

            default:
                break;
        }
    }

    searchTable = (event) => {
        if (event.target.value === '') {
            this.setState({
                isSearched: false,
                updatedList: this.state.fetched_data
            })
        }
        else {
            this.setState({
                isSearched: true
            })
            var searchKeyword = this.state.searchKeyword
            switch (searchKeyword) {
                case 'company':
                    var temp = []
                    for (var i = 0; i < this.state.fetched_data.length; i++) {
                        if ((this.state.fetched_data[i]['Company'].toLowerCase()).includes((event.target.value).toLowerCase())) {
                            temp.push(this.state.fetched_data[i])
                        }
                        this.setState({
                            searchedList: temp
                        })
                    }
                    break;

                case 'user':
                    var temp = []
                    for (var i = 0; i < this.state.fetched_data.length; i++) {
                        if ((this.state.fetched_data[i]['userid'].toLowerCase()).includes((event.target.value).toLowerCase())) {
                            temp.push(this.state.fetched_data[i])
                        }
                        this.setState({
                            searchedList: temp
                        })
                    }
                    break;
            }
        }
    }

    removeFilters = () => {
        this.setState({ isSearched: false, searchKeyword: 'user' })
        document.getElementById('searchInput').value = ''
    }

    updateDatasetStatus = (dataset, event) => {
        // logActivity([
        //     {
        //         'screen': 'Summary',
        //         'module': 'Summary',
        //         'user_activity': `status updated for ${dataset['dataset']}`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        var temp = {}
        temp['dataset'] = dataset['dataset']
        temp['status'] = event.target.value
        this.updateStatus(temp)
    }

    dumpDatasetStatus = () => {
        Axios.post(Urls.summary, { 'key': 'dump', data: datasetStatus })
            .then(response => {
                toast.success('Data updated')
            })
            .catch(error => {
                console.error(error)
                toast.error('Error while processing your request')
            })
    }

    updateStatus = (status) => {
        // logActivity([
        //     {
        //         'screen': 'Summary',
        //         'module': 'Summary',
        //         'user_activity': `status updated for datasets`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        var isExisting = false
        for (var i = 0; i < datasetStatus.length; i++) {
            if (status['dataset'] === datasetStatus[i]['dataset']) {
                isExisting = true
                break
            }
        }
        if (isExisting === true) {
            datasetStatus[i] = status
        }
        else {
            datasetStatus.push(status)
        }
        console.log(datasetStatus)
    }


    processedFileHandle = (dataset) => {
        // logActivity([
        //     {
        //         'screen': 'Summary',
        //         'module': 'Summary',
        //         'user_activity': `dataset ${dataset['dataset']} clicked`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        var body = {
            "dataset_id": dataset['dataset']
        }
        console.log(body)
        document.getElementById("header").style.opacity = "0.5"
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.monitoring, body)
                .then(response => {
                    this.setState({
                        loader: false
                    })
                    document.getElementById("header").style.opacity = "1"
                    console.log(body['dataset_id'])
                    localStorage.setItem("dataset_id", body['dataset_id'])
                    this.props.history.push({
                        pathname: url[response.data.screen]
                    })
                })
                .catch(error => {
                    this.setState({
                        loader: false
                    })
                    document.getElementById("header").style.opacity = "1"
                    toast.error("Error while processing your request")
                    console.log(error)
                })
        })
    }

    downloadRawFile = (dataset) => {
        document.getElementById("header").style.opacity = "0.5"
        const body = {
            "dataset_id": dataset['dataset'],
            "key": "raw"
        }
        // logActivity([
        //     {
        //         'screen': 'Summary',
        //         'module': 'Summary',
        //         'user_activity': `raw file for ${dataset['dataset']} downloaded`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        console.log(body)
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.download_file, body)
                .then(response => {
                    console.log(response.data.filename)
                    var current_timestamp = new Date();
                    current_timestamp = current_timestamp.toISOString();
                    let body = {
                        'action': 'download',
                        'accountName': 'lnclientdata',
                        'containerName': 'dcrawfile',
                        'fileName': response.data.filename.includes('#') ? response.data.filename.replace('#', '---') : response.data.filename
                    }
                    Axios.post(Urls.fileService, body)
                        .then(response => {
                            console.log("Blob URL data")
                            console.log(response.data)
                            window.open(response.data.url)
                            document.getElementById("header").style.opacity = "1"
                            this.setState({ loader: false })
                        })
                        .catch(error => {
                            console.log(error)
                            this.setState({ loader: false })
                            document.getElementById("header").style.opacity = "1"
                            toast.error("Error while downloading your file")
                        })

                })
                .catch(error => {
                    console.log(error)
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    toast.error("We can't find your RAW file")
                })
        })
    }

    gotoReview = (dataset) => {
        // logActivity([
        //     {
        //         'screen': 'Summary',
        //         'module': 'Summary',
        //         'user_activity': `review for ${dataset['dataset']} clicked`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        // console.log(s)
        localStorage.removeItem('review-dataset')
        sessionStorage.setItem('review-dataset', dataset['dataset'])
        this.props.history.push({
            pathname: '/review-screen'
        })
    }

    goBack = () => {
        this.props.history.push({ pathname: "/user_details" })
    }

    render() {
        const summary = this.state.fetched_data
        const searchedList = this.state.searchedList
        return (
            <div id="header">
                <ToastContainer />
                <div className="body" align="center">
                    {
                        sessionStorage.getItem('role') === 'user' ? (
                            <>
                                <div className='row table-header'>
                                    <div className='form-group searchBy'>
                                        <select onChange={(event) => this.setState({ searchKeyword: event.target.value })} className='form-control'>
                                            <option value='user'>
                                                By User ID
                                            </option>
                                            <option value='company'>
                                                By Company Name
                                            </option>
                                        </select>
                                    </div>
                                    <div className='form-group searchInput'>
                                        <input id='searchInput' onChange={this.searchTable} className='form-control' placeholder='Your query' />
                                    </div>
                                    <span onClick={this.removeFilters} className='remove-filter'>
                                        <i className='fa fa-times'></i>
                                    </span>
                                </div>
                            </>
                        ) : null
                    }
                    <br />
                    <table border="1" id="summaryTable">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>User ID</th>
                                <th>Company Name</th>
                                <th>
                                    <span onClick={() => this.sort('spend')}>
                                        Spend <span className='sort-option'> <i className='fa fa-sort'></i> </span>
                                    </span>
                                </th>
                                <th>
                                    <span onClick={() => this.sort('volume')}>
                                        Volume <span className='sort-option'> <i className='fa fa-sort'></i> </span>
                                    </span>
                                </th>
                                <th>Sector</th>
                                <th>Received Date</th>
                                <th>Processed Filename</th>
                                <th>Raw Filename</th>
                                <th>Timestamp</th>
                                <th>Review Dataset</th>
                                <th>
                                    <span onClick={() => this.sort('status')}>
                                        Status <span className='sort-option'> <i className='fa fa-sort'></i> </span>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.isSearched === false ? (
                                    <>
                                        {
                                            (summary.length === 0) ? (
                                                <tr>
                                                    <td colSpan="12">No data available</td>
                                                </tr>
                                            ) : (
                                                summary.map((s, i) => <tr>
                                                    <td> {i + 1} </td>
                                                    <td> {s['userid']} </td>
                                                    <td> {s['Company']} </td>
                                                    <td> {s['spend']} </td>
                                                    <td> {s['volume']} </td>
                                                    <td> {s['sector']} </td>
                                                    <td> {s['Received Date']} </td>
                                                    <td> <a id={i} onClick={() => this.processedFileHandle(s)}>{s['dataset']}</a> </td>
                                                    <td> <a id={i} onClick={() => this.downloadRawFile(s)}>{s['Filename']}</a> </td>
                                                    <td> {s['timestamp']} </td>
                                                    <td>
                                                        <a id={i} onClick={() => this.gotoReview(s)} >Review</a>
                                                    </td>
                                                    <td>
                                                        <select disabled={false} onChange={(event) => this.updateDatasetStatus(s, event)} className='form-control'>
                                                            <option disabled={true} selected>
                                                                -- SELECT DATASET STATUS --
                                                                </option>
                                                            <option selected={s['status'] === 'Pending' ? true : false} value='Pending'>
                                                                Pending
                                                                </option>
                                                            <option selected={s['status'] === 'Ready' ? true : false} value='Ready'>
                                                                Ready
                                                                </option>
                                                            <option selected={s['status'] === 'Duplicate' ? true : false} value='Duplicate'>
                                                                Duplicate Dataset
                                                                </option>
                                                            <option selected={s['status'] === 'Reprocess' ? true : false} value='Reprocess'>
                                                                Reprocess
                                                                </option>
                                                            <option selected={s['status'] === 'Delete' ? true : false} value='Delete'>
                                                                Delete
                                                                </option>
                                                        </select>
                                                    </td>
                                                </tr>))
                                        }
                                    </>
                                ) : (
                                    <>
                                        {
                                            searchedList.length === 0 ? (
                                                <tr>
                                                    <td colSpan="12">No data available</td>
                                                </tr>
                                            ) : (
                                                <>
                                                    {
                                                        searchedList.map((s, i) => <tr>
                                                            <td> {i + 1} </td>
                                                            <td> {s['userid']} </td>
                                                            <td> {s['Company']} </td>
                                                            <td> {s['spend']} </td>
                                                            <td> {s['volume']} </td>
                                                            <td> {s['sector']} </td>
                                                            <td> {s['Received Date']} </td>
                                                            <td> <a id={i} onClick={() => this.processedFileHandle(s)}>{s['dataset']}</a> </td>
                                                            <td> <a id={i} onClick={() => this.downloadRawFile(s)}>{s['Filename']}</a> </td>
                                                            <td> {s['timestamp']} </td>
                                                            <td>
                                                                <a id={i} onClick={() => this.gotoReview(s)} >Review</a>
                                                            </td>
                                                            <td>
                                                                <select disabled={false} onChange={(event) => this.updateDatasetStatus(s, event)} className='form-control'>
                                                                    <option disabled={true} selected>
                                                                        -- SELECT DATASET STATUS --
                                                                            </option>
                                                                    <option selected={s['status'] === 'Pending' ? true : false} value='Pending'>
                                                                        Pending
                                                                            </option>
                                                                    <option selected={s['status'] === 'Ready' ? true : false} value='Ready'>
                                                                        Ready
                                                                            </option>
                                                                    <option selected={s['status'] === 'Duplicate' ? true : false} value='Duplicate'>
                                                                        Duplicate Dataset
                                                                            </option>
                                                                    <option selected={s['status'] === 'Reprocess' ? true : false} value='Reprocess'>
                                                                        Reprocess
                                                                            </option>
                                                                    <option selected={s['status'] === 'Delete' ? true : false} value='Delete'>
                                                                        Delete
                                                                            </option>
                                                                </select>
                                                            </td>
                                                        </tr>)
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </tbody>
                    </table>
                    <br />
                </div>
                <Loader isLoading={this.state.loader} />
                <div className="footer_div">
                    <button className="btn btn-danger" onClick={this.goBack}>Go Back</button>
                    <button disabled={false} onClick={this.dumpDatasetStatus} className="btn btn-success"> Update Status </button>
                </div>
            </div>
        )
    }
}

export default Summary
